import React from 'react';

import {
  FEATURE_GATES,
  PermissionFilter,
  GlobalFeatureGateFilter
} from '@sopranodesign/pulse-auth';
import {
  Panel,
  PageWrapper
} from '@sopranodesign/pulse-components';

import { Sitemap } from '../Components';

const SitemapPage = () => (
  <PageWrapper beta="true" header="Website" subheader="Configure your Website">
    <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI}>
      <PermissionFilter can="view generative ai resource">
        <Panel>
          <Sitemap />
        </Panel>
      </PermissionFilter>
    </GlobalFeatureGateFilter>
  </PageWrapper>
);

export default SitemapPage;